import React, { useState } from 'react';
import { Result as AntResult, Button, } from 'antd';
import { Navigate } from 'react-router-dom';
import { PUBLIC_ROUTE} from '@router/route.constants';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Result = styled(AntResult)`
  .ant-result-title, .ant-result-subtitle {
    color: ${props => props.theme.textColor} !important;
  }
  .ant-btn-primary {
    background: ${props => props.theme.white} !important;
  }
`;

const Page404 = () => {
  const { t } = useTranslation()
  const [redirectReferer, setRedirectReferer] = useState(false);

  const back = () => {
    setRedirectReferer(true);
  }

  if (redirectReferer) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} replace />
  }

  return (
    <Result
      status="404"
      title="404"
      subTitle={t("error.subtitle404")}
      extra={
        <Button
          type="primary"
          onClick={back}
        >
          {t("error.backHome")}
        </Button>
      }
    />
  );
}

export default Page404;